import React, {FC} from 'react';

import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';

const RenameNotification: FC = () => {
    const localizedStrings = getLocalizedStrings();

    return <span tabIndex={-1}>{localizedStrings[localizationKeys.DEVICE_RENAME_NOTIFICATION_SUCCESS_TEXT]}</span>;
};

export default RenameNotification;
